import Enrollment from './EnrollmentQuery'

export default Enrollment
